export const ProductInfoStrings = {
  elevatorCallApi: 'Add elevator call-giving functionalities to your smart building applications',
  serviceRobotApi: 'Enable robots to make elevator calls and use elevators autonomously, serving multiple floors',
  equipmentStatusApi:
    'Get equipment operating status and service status information, and integrate it into your building management system',
  serviceInfoApi:
    'Integrate information about service orders, call-outs and repairs into your building management system',
  rtm: 'Subscribe to events and start receiving them to monitor your equipments',
}
